import Vue from 'vue'
import VueRouter from 'vue-router'
import RequireAuthentication from './guards/require-authentication'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'main',
        redirect: "/callback",
    },
    {
        path: '/callback',
        name: 'callback',
        component: () => import('../views/defaults/Callback.vue'),
    },
    {
        path: '/to-store',
        name: 'Store banner',
        component: () => import('../views/student/StoreBanner.vue'),
    },
    {
        path: '/user',
        // name: 'user',
        component: () => import('../views/student/Main.vue'),
        beforeEnter: RequireAuthentication,
        children: [
            {
                path: 'home',
                name: 'home',
                component: () => import('../views/student/Home.vue'),
            },
            {
                path: '',
                name: 'index',
                redirect: 'home',
            },
            {
                path: 'book/:book_id',
                name: 'book',
                component: () => import('../views/student/BookReading.vue'),
                props: true,
            },
            {
                path: 'challenge',
                name: 'challenge',
                component: () => import('../views/student/Challenge.vue'),
            },
            {
                path: 'beginningchallenge',
                name: 'beginningchallenge',
                component: () => import('../views/student/BeginningChallenge.vue'),
            },
            {
                path: 'profile',
                name: 'profile',
                component: () => import('../views/student/Profile.vue'),
            },
            {
                path: 'store',
                name: 'store',
                component: () => import('../views/student/Store.vue'),
            },
            {
                path: 'library',
                name: 'library',
                component: () => import('../views/student/Library.vue'),
            },
            {
                path: 'ranking',
                name: 'ranking',
                component: () => import('../views/student/Ranking.vue'),
            },
            {
                path: 'tester/:challenge_id',
                name: 'challenge_tester',
                props: true,
                component: () => import('../views/student/Challenge.vue'),
            },
        ],
    },
    {
        path: '*',
        component: () => import('../views/defaults/NotFound.vue'),
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

export default router
